import {
  ItemType,
  type Addon,
  type Subscription,
} from '@bbkPricingPage/types/pricing-table-types';

export const getSubscribedPlanQuantity = (
  subscription: Subscription | undefined,
  priceId: string
) => {
  return subscription?.subscription_items?.find(
    (item) => item.billing_system_item_price_id === priceId
  )?.quantity;
};

export const getSubscribedAddonQuantities = (
  subscription: Subscription,
  allAddons: Addon[]
) => {
  const priceIdToAddonId = new Map<string, string>();
  const result: {
    addonId: string;
    addonPriceId: string;
    quantity?: number;
  }[] = [];

  allAddons.forEach((addon) => {
    addon.prices.forEach((price) => {
      priceIdToAddonId.set(price.billing_system_id, addon.billing_system_id);
    });
  });

  for (const subItem of subscription.subscription_items) {
    if (
      subItem.item_type !== ItemType.addon ||
      subItem.item_type === undefined ||
      subItem.item_type === null
    )
      continue;
    const addonPriceId = subItem.billing_system_item_price_id;
    const addonId = priceIdToAddonId.get(addonPriceId);
    if (addonId) {
      result.push({
        addonId,
        addonPriceId,
        quantity: subItem.quantity,
      });
    }
  }
  return result;
};
